<template>
    <div>
        <div class="fixed top-0 right-0 z-50 inline-block m-3 text-teal-100 bg-teal-500 rounded-lg">
            <div class="flex items-center p-3 bg-green-100 border-2 border-green-600 rounded-md shadow-lg">
                <img src="/img/icons/audioBookCompletedTick.svg" alt="coin" class="w-10 h-10 image-view">
                <div class="ml-2 text-center">
                    <h1 class="text-xl font-bold text-green-600">Successfully!!</h1>
                    <p class="text-base font-semibold leading-6 text-green-700">{{ message }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['message']
    }
</script>